import { motion } from 'framer-motion';
import { HORECA } from '@/constants/testIds';
import KidsStrip from './KidsStrip';
import { Coins, Tag, BadgeCheck, Truck, MapPinned, Package } from 'lucide-react';

const VALUES = [
  {
    icon: Coins,
    title: 'Toptan Fiyat',
    body: 'HORECA hacimlerine özel kademeli fiyatlandırma, yıllık sözleşme avantajları.',
    highlight: true,
    hint: 'Aylık palet',
  },
  {
    icon: BadgeCheck,
    title: 'Sertifikalı Organik',
    body: 'Tarım ve Orman Bakanlığı denetimli, izlenebilir organik üretim zinciri.',
    hint: 'TR-OT-01',
  },
  {
    icon: Tag,
    title: 'Private Label',
    body: 'Kendi markanıza özel etiket, tasarım ve gramaj seçenekleriyle özel üretim.',
    hint: 'Min. 500 adet',
  },
  {
    icon: Truck,
    title: 'Düzenli Sevkiyat',
    body: 'Haftalık veya aylık planlı teslimat; stok endişesi yaşamadan işletme akışı.',
    hint: 'Sabit çizelge',
  },
  {
    icon: MapPinned,
    title: 'Türkiye Geneli',
    body: '81 il için anlaşmalı lojistik ağı, hassas ürünler için özel taşıma.',
    highlight: true,
    hint: 'Tüm iller',
  },
  {
    icon: Package,
    title: 'Özel Paketleme',
    body: 'Porsiyonluk kavanoz, mini jar ve amenity setleri — kahvaltı büfelerine özel.',
    hint: 'Mini · Midi · Palet',
  },
];

const item = {
  hidden: { opacity: 0, y: 24 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function ValueProps() {
  return (
    <section
      id="avantajlar"
      data-testid={HORECA.valuePropsSection}
      className="relative paper-kraft text-[#1F1F1F] py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 mb-16">
          <div className="lg:col-span-7">
            <span className="eyebrow text-[#B03A2E] mb-4 block">Neden Lutfiye Horeca</span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight font-light">
              Küçük ölçekli üreticinin ruhu,
              <span className="italic text-[#B08834]"> kurumsal tedarik</span> disipliniyle.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pt-4 text-[#5A5145] text-base md:text-lg leading-relaxed font-body font-light">
            HORECA kanalınıza değer katan altı yaklaşım. Her biri, sofranıza
            gelen kavanozun ardındaki söz olarak var.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#1F1F1F]/12">
          {VALUES.map((v, i) => {
            const Icon = v.icon;
            const highlight = v.highlight;
            return (
              <motion.div
                key={v.title}
                custom={i}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: '-60px' }}
                variants={item}
                className={`${
                  highlight
                    ? 'bg-[#1F1F1F] text-[#FBF7EE]'
                    : 'bg-[#FBF7EE] text-[#1F1F1F] hover:bg-[#FFFDF7]'
                } p-8 md:p-10 group relative transition-colors`}
              >
                <div className="flex items-start justify-between mb-8">
                  <Icon
                    className={`w-9 h-9 ${highlight ? 'text-[#B08834]' : 'text-[#B03A2E]'}`}
                    strokeWidth={1.2}
                  />
                  <span
                    className={`font-display text-xs ${
                      highlight ? 'text-[#FBF7EE]/50' : 'text-[#1F1F1F]/35'
                    } mt-1`}
                  >
                    0{i + 1} / 06
                  </span>
                </div>
                <h3
                  className={`font-display text-2xl md:text-3xl leading-tight mb-3 ${
                    highlight ? 'text-[#FBF7EE]' : 'text-[#1F1F1F]'
                  }`}
                >
                  {v.title}
                </h3>
                <p
                  className={`text-sm md:text-base leading-relaxed font-body font-light ${
                    highlight ? 'text-[#FBF7EE]/70' : 'text-[#5A5145]'
                  }`}
                >
                  {v.body}
                </p>
                <div className="mt-8 pt-4 border-t border-current/15 flex items-center justify-between">
                  <span
                    className={`eyebrow ${
                      highlight ? 'text-[#B08834]' : 'text-[#B03A2E]'
                    }`}
                  >
                    {v.hint}
                  </span>
                  <span
                    className={`h-px w-8 group-hover:w-16 transition-all duration-500 ${
                      highlight ? 'bg-[#B08834]' : 'bg-[#B03A2E]/60'
                    }`}
                  />
                </div>
              </motion.div>
            );
          })}
        </div>

        {/* Kids strip */}
        <div className="mt-20">
          <KidsStrip darkBg={false} />
          <div className="text-center eyebrow text-[#5A5145]/70 mt-4">
            El ele, doğadan sofralara — Lutfiye ailesi
          </div>
        </div>
      </div>
    </section>
  );
}
